var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCrackedEgg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.869629,
    y: 0.739136,
    width: 45.6788,
    height: 45.6788,
    rx: 22.8394,
    fill: "#FFF5D9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_202_20)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.0006 24.2492L31.7832 26.1334C31.5181 26.3587 31.128 26.3561 30.8658 26.1275L27.6639 23.3353L24.462 26.1275C24.3296 26.243 24.1647 26.3007 23.9999 26.3007C23.835 26.3007 23.6702 26.243 23.5378 26.1275L20.3358 23.3353L17.134 26.1275C16.8717 26.3562 16.4817 26.3587 16.2166 26.1334L13.9992 24.2492C13.9227 24.8116 13.8828 25.3592 13.8828 25.8828C13.8828 28.5852 14.9351 31.1259 16.846 33.0368C18.7568 34.9477 21.2975 36 23.9999 36C26.7023 36 29.2429 34.9477 31.1538 33.0368C33.0647 31.1259 34.1171 28.5852 34.1171 25.8828C34.1171 25.3592 34.0771 24.8116 34.0006 24.2492Z",
    fill: "#EDA10D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2479 16.9625C30.3003 15.4913 29.235 14.3147 28.0813 13.4651C26.7611 12.4929 25.3879 12 23.9999 12C22.612 12 21.2389 12.4929 19.9187 13.4651C18.7651 14.3147 17.6996 15.4914 16.7521 16.9625C15.6291 18.7061 14.7765 20.7195 14.303 22.662L16.666 24.6698L19.8738 21.8725C20.1386 21.6415 20.5333 21.6415 20.7981 21.8724L24 24.6646L27.202 21.8724C27.4667 21.6414 27.8613 21.6415 28.1262 21.8725L31.334 24.6698L33.697 22.6619C33.2234 20.7194 32.3709 18.7061 31.2479 16.9625Z",
    fill: "#EDA10D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_202_20"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(12 12)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrackedEgg);
export default __webpack_public_path__ + "static/media/cracked-egg.49105151.svg";
export { ForwardRef as ReactComponent };